export class MainService {
  router = null
  app = null

  constructor(options) {
    this.options = options
  }

  newVueRouter() {

  }

  newVue() {

  }

  render() {
    console.log('[main] MainService render')
  }

  unmountCache() {

  }
}
